// extracted by mini-css-extract-plugin
export default {"root":"_3h31bU_7DdUrxh2xFcOI0v","title":"_38PCL8WHiQ3CGy8lopaDfx","synopsis":"_18FbIIkbA5rGrAGErWQI4p","type":"_307qhSP5C8ph7AhIkyWq9y","clock":"_13Y2p0BeAIaRKDDujKdzr-"};